import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class SectionService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/bolum/get-list`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new SectionService();
